import BasicLayout from '@/layouts/Basic';
import {wrapModelLoaderAsBeforeRouterEnterHook} from '../lib/model';

const importEnv = require('./_import_' + process.env.NODE_ENV);

export default [
    {
        path: '/imageCreate',
        name: 'imageCreateWork',
        component: BasicLayout,
        children: [
            {
                path: '/',
                redirect: {
                    name: 'imageCreateWork'
                }
            },
            {
                path: 'work',
                name: 'imageCreateWork',
                meta: {
                    authorizedRole: 'digital_education_image'
                },
                component: importEnv('Image/work/index')
            },
            {
                path: 'marketingV2',
                name: 'marketImageCreateV2',
                meta: {
                    theme: 'image',
                    authorizedRole: ['digital_human_list'],
                    source: 'poster'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                    {name: 'ImageCreate', loader: () => import('../model/ImageCreate')},
                    {name: 'specialCreate', loader: () => import('../model/specialCreate')},
                    {name: 'myCreation', loader: () => import('../model/myCreation')}
                ]),
                component: importEnv('V2/image/market/index')
            },
            // 需要单独配置一个不带uid的路由 ，不然通用链接在录入BOD群的时候无可匹配路由会报错
            {
                path: 'coverPictureV2',
                name: 'coverPictureV2',
                meta: {
                    theme: 'image',
                    authorizedRole: ['digital_human_list'],
                    source: 'poster'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                    {name: 'ImageCreate', loader: () => import('../model/ImageCreate')},
                    {name: 'specialCreate', loader: () => import('../model/specialCreate')},
                    {name: 'myCreation', loader: () => import('../model/myCreation')}
                ]),
                component: importEnv('V2/image/coverPicture/index')
            },
            {
                path: 'fromText',
                name: 'imageCreateFromText',
                meta: {
                    authorizedRole: 'digital_education_image'
                },
                beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook('ImageCreate', () =>
                    import('../model/ImageCreate')
                ),
                component: importEnv('ImageCreate/create/AiContent')
            }
        ]
    }
];
